var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97011 3.03006L8.50002 2.50015C9.0523 1.94787 9.0523 1.05244 8.50002 0.500151C7.94773 -0.0521341 7.0523 -0.0521333 6.50002 0.500151L5.95753 1.04264C6.4188 1.88329 7.11726 2.57611 7.97011 3.03006ZM4.50209 2.49807L1.8564 5.14377C1.43134 5.56883 1.21881 5.78136 1.07907 6.04246C0.939336 6.30356 0.88039 6.59828 0.7625 7.18773L0.647104 7.76472C0.580582 8.09733 0.547321 8.26363 0.641929 8.35824C0.736537 8.45285 0.902842 8.41959 1.23545 8.35306L1.81243 8.23767L1.81244 8.23766C2.40189 8.11978 2.69661 8.06083 2.95771 7.9211C3.2188 7.78137 3.43132 7.56884 3.85636 7.14381L3.85638 7.14379L3.8564 7.14377L6.51082 4.48935C5.71004 3.96919 5.02669 3.29029 4.50209 2.49807Z",
    fill: "#3DB2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.f3e93c08dac9b32f29949abb7d87da03.svg";
export { ForwardRef as ReactComponent };